/* eslint-disable no-unused-vars */
import $ from 'jquery';
import Tooltip from 'tooltip.js/dist/umd/tooltip';

// $(document).ready(() => {
//   const $validationSelector = $('.js-validation');
//
//   if ($validationSelector.length > 0) {
//     $validationSelector.each((i, item) => {
//       const $item = $(item);
//       const instance = new Tooltip($item, {
//         trigger: 'focus',
//       });
//       // instance.show();
//     });
//   }
// });



// WEBPACK FOOTER //
// ./js/components/init-validation-tooltip.js